import React from "react";
import { Link } from "gatsby";
import * as styles from "./Logo.module.css";

const Logo = ({ text, url }) => {
  return (
    <Link to={url}>
      <div
        class={`${styles.hero} ${styles.glitch} ${styles.layers}`}
        data-text={text}
      >
        <span>{text}</span>
      </div>
    </Link>
  );
};

const H2 = ({ text }) => {
  return (
    <div
      class={`${styles.hero} ${styles.glitch} ${styles.layers}`}
      data-text={text}
    >
      <span>{text}</span>
    </div>
  );
};

export { Logo, H2 };
